export default {
    name: 'Spinner',
    data() {
        return {
        };
    },
};